import {AppLoader} from '@common';
import Router from 'next/router';
import PropTypes from 'prop-types';
import {Fragment, useEffect} from 'react';
import {useSelector} from 'react-redux';

// ----------------------------------------------------------------------

StaffGuard.propTypes = {
  children: PropTypes.node,
};

export default function StaffGuard({children}) {
  const {user, isSuperAdmin} = useSelector(
    ({authentication}) => authentication,
  );

  useEffect(() => {
    if (!user.isNhanVien) {
      if (!isSuperAdmin) {
        Router.push('/404');
      }
    }
  }, [user, isSuperAdmin]);

  return user.isNhanVien || isSuperAdmin ? (
    <Fragment>{children}</Fragment>
  ) : (
    <AppLoader />
  );
}
